import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const DonutChart = ({ currency }) => {
	const updateCenterLabel = (chart) => {
		const series = chart.series[0];
		const total = series.data.reduce((sum, point) => (point.visible ? sum + point.y : sum), 0).toFixed(0);
		let customLabel = chart.options.chart.custom.label;

		if (!customLabel) {
			customLabel = chart.options.chart.custom.label = chart.renderer
				.label(
					`<span><strong>${currency}${total.replace(
						/(?<!\.\d*)(?<=\d)(?=(?:\d{3})+(?!\d))/g,
						",",
					)}</strong></span>`,
				)
				.css({
					color: "#000",
					textAnchor: "middle",
					fontFamily: "Open Sans",
				})
				.add();
		} else {
			customLabel.attr({
				text: `<span><strong>${currency}${total.replace(
					/(?<!\.\d*)(?<=\d)(?=(?:\d{3})+(?!\d))/g,
					",",
				)}</strong></span>`,
			});
		}

		const x = series.center[0] + chart.plotLeft;
		const y = series.center[1] + chart.plotTop - customLabel.attr("height") / 2;

		customLabel.attr({ x, y });
		customLabel.css({ fontSize: `${series.center[2] / 8}px` });
	};

	const options = {
		chart: {
			type: "pie",
			height: 300,
			custom: {},
			events: {
				render() {
					const chart = this,
						series = chart.series[0];
					let customLabel = chart.options.chart.custom.label;
					const total = series.data
						.reduce((sum, point) => (point.visible ? sum + point.y : sum), 0)
						.toFixed(0);

					if (!customLabel) {
						customLabel = chart.options.chart.custom.label = chart.renderer
							.label(`<strong>${total.replace(/(?<!\.\d*)(?<=\d)(?=(?:\d{3})+(?!\d))/g, ",")}</strong>`)
							.css({
								color: "#000",
								textAnchor: "middle",
							})
							.add();
					}

					const x = series.center[0] + chart.plotLeft,
						y = series.center[1] + chart.plotTop - customLabel.attr("height") / 2;

					customLabel.attr({
						x,
						y,
					});

					// Set font size based on chart diameter
					customLabel.css({
						fontSize: `${series.center[2] / 8}px`,
					});
				},
				redraw: function () {
					const chart = this;
					updateCenterLabel(chart);
				},
			},
		},
		accessibility: {
			point: {
				valueSuffix: "",
			},
		},
		title: {
			text: null,
		},
		tooltip: {
			formatter: function () {
				const formattedValue =
					currency + this.y.toFixed(0).replace(/(?<!\.\d*)(?<=\d)(?=(?:\d{3})+(?!\d))/g, ",");
				return `${this.series.name}: <b>${formattedValue}</b>`;
			},
			//pointFormat: `{series.name}: <b>${currency}{point.y:.0f}</b>`,
			style: {
				fontSize: "14px",
			},
		},
		legend: {
			enabled: true,
			useHTML: true,
			labelFormatter: function () {
				// Custom HTML for legend item
				return `<div style="background-color: ${this.color}; padding: 5px; border-radius: 5px"><span class="legend-item" style=" color: white;">${this.name}</span></div<`;
			},
			symbolHeight: 0, // Remove the symbol
			symbolWidth: 0, // Remove the symbol
			verticalAlign: "bottom",
			align: "center",
			itemStyle: {
				fontSize: "12px",
				fontWeight: "600",
			},
		},
		plotOptions: {
			series: {
				allowPointSelect: true,
				cursor: "pointer",
				borderRadius: 5,
				dataLabels: [
					{
						enabled: false,
						distance: 20,
						format: "{point.name}",
					},
					{
						enabled: false,
						distance: -15,
						format: "{point.percentage:.0f}%",
						style: {
							fontSize: "0.9em",
						},
					},
				],
				showInLegend: true,
			},
		},
		series: [
			{
				name: "Salary",
				colorByPoint: true,
				innerSize: "70%",
				data: [
					{
						name: "Vacation",
						y: 22000,
					},
					{
						name: "Sick",
						y: 12000,
					},
					{
						name: "Overtime",
						y: 37039,
					},
					{
						name: "Allowances",
						y: 16000,
					},
				],
			},
		],
		credits: {
			enabled: false,
		},
		responsive: {
			rules: [
				{
					condition: {
						maxWidth: 600,
					},
					chartOptions: {
						legend: {
							layout: "horizontal",
							align: "center",
							verticalAlign: "bottom",
						},
					},
				},
			],
		},
	};

	return (
		<div className="width-full">
			<HighchartsReact
				highcharts={Highcharts}
				options={options}
			/>
		</div>
	);
};

export default DonutChart;
